import "./AssetManagerTemplate.css";

import React from "react";

import { SeedActiveElement } from "../../models";
import { SeedFooter, SeedNavigation } from "../../widget";

export interface AssetManagerTemplateProps {
  children: React.ReactNode;
  activeElement?: SeedActiveElement;
}

export const AssetManagerTemplate = ({ activeElement, children }: AssetManagerTemplateProps): JSX.Element => {
  return (
    <div className="AssetManagerScreen">
      <SeedNavigation activeElement={activeElement} />
      <div className="AssetManagerContainer">
        {children} <SeedFooter />
      </div>
    </div>
  );
};
